import { CreateBatchFromPartImageItemsRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_ACTIVITY_QUERY_KEY } from '../part-finder-activity/query';
import { PART_FINDER_REPORTS_QUERY_KEY } from '../part-finder-reports/query';

export const useCreateBatchFromPartImageItems = (identificationId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useMutation({
    mutationFn: async (request: CreateBatchFromPartImageItemsRequest) => {
      const response = await api.tenants.createBatchFromPartImageItems(tenantId, identificationId, request);
      return response.data.partFinderBatchId;
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [PART_FINDER_REPORTS_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [PART_FINDER_ACTIVITY_QUERY_KEY], exact: false });
    },
  });
};
